export const REQUIRED_TRUSTPILOT_CLASS_NAME = "trustpilot-widget";

export const SIMPLYBUSINESS_UNIT_ID = "5ca35a3da72b330001954cef";

export const SIMPLYBUSINESS_UNIT_IDS = {
  "en-US": "5ca35a3da72b330001954cef", // US business unit ID
  "en-GB": "56b1db010000ff0005887125", // UK business unit ID
};

export const TRUSTPILOT_LINKS = {
  "en-US": "https://www.trustpilot.com/review/simplybusiness.com",
  "en-GB": "https://www.trustpilot.com/review/simplybusiness.co.uk",
};

// To obtain template IDs, login to Trustpilot business account > go to the "Share & Promote" section >
// select "Website widgets" > choose the desired widget design > within the customization options, you will see the "Template ID"
export const TRUSTPILOT_TEMPLATE_IDS = {
  "micro-combo": "5419b6ffb0d04a076446a9af",
  mini: "53aa8807dec7e10d38f59f32",
  carousel: "53aa8912dec7e10d38f59f36",
  horizontal: "5406e65db0d04a09e042d5fc",
  "micro-star": "5419b732fbfb950b10de65e5",
};

export const TRUSTPILOT_WIDGET = {
  // Keys based on actual widget names
  // https://support.trustpilot.com/hc/en-us/articles/360019826379-TrustBox-widget-overview
  "micro-combo": {
    templateId: TRUSTPILOT_TEMPLATE_IDS["micro-combo"],
    className: "--is-variant-micro-combo",
    styles: {
      height: "25px",
    },
  },
  mini: {
    templateId: TRUSTPILOT_TEMPLATE_IDS["mini"],
    className: "--is-variant-mini",
    styles: {
      width: "300px",
      height: "150px",
    },
  },
  carousel: {
    templateId: TRUSTPILOT_TEMPLATE_IDS["carousel"],
    className: "--is-variant-carousel",
    styles: {
      height: "150px",
    },
  },
  horizontal: {
    templateId: TRUSTPILOT_TEMPLATE_IDS["horizontal"],
    className: "--is-variant-horizontal",
    styles: {
      height: "28px",
    },
  },
  "micro-star": {
    templateId: TRUSTPILOT_TEMPLATE_IDS["micro-star"],
    className: "--is-variant-micro-star",
    styles: {
      height: "24px",
    },
  },
};
